import { render, staticRenderFns } from "./LogsSinamed.vue?vue&type=template&id=6060c13a"
import script from "./LogsSinamed.vue?vue&type=script&lang=js"
export * from "./LogsSinamed.vue?vue&type=script&lang=js"
import style0 from "./LogsSinamed.vue?vue&type=style&index=0&id=6060c13a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports